import React from 'react';
import {
  SalesCenterForm,
  SalesCenterRules,
  SalesCenterLayout,
  SalesCenterWorkflow,
  SalesCenterApiContainer,
} from 'modules/dealSheet';

export const SalesCenterConfiguration = () => (
  <SalesCenterApiContainer>
    {({ listOfConfigs, config, onConfigureWorkflow, isLoading }) => (
      <SalesCenterLayout
        form={<SalesCenterForm />}
        rules={<SalesCenterRules workflow={config} />}
        workflow={
          <SalesCenterWorkflow
            isLoading={isLoading}
            listOfWorkflow={listOfConfigs}
            onConfigureWorkflow={onConfigureWorkflow}
          />
        }
      />
    )}
  </SalesCenterApiContainer>
);
